import ProgressBar from "@ramonak/react-progress-bar";
import { useQueryClient } from "@tanstack/react-query";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";

import emptyImage from "../../../assets/images/emptyAvatar.svg";
import useFileUpload from "../../../hooks/useFileUpload";
import { api } from "../../../utils/axios/Config";
import { cn, handleErrorApi } from "../../../utils/utils";
import Loader from "../../shared/Loader";

const BusinessImageContainer = ({ src, width, height, className, businessId, businessType }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [fileUrl, setFileUrl] = useState("");
  const [file, setFile] = useState([]);
  const [fileIsUploading, setFileIsUploading] = useState(false);

  const { progress, uploading, error, uploadFile } = useFileUpload();

  const handleUpload = async ({ file, pic_type }) => {
    setFileIsUploading(true);

    try {
      const session = await uploadFile({ file, pic_type });

      if (session?.status === 200) {
        const { url } = session.data;

        try {
          const res = api.patch(`businesses/real/update/logo/${businessId}/`, {
            logo: url,
          });

          res.then((res) => {
            if (res?.status === 200 || res?.status === 201) {
              queryClient.invalidateQueries({
                queryKey: ["bussinessData"],
              });
              queryClient.invalidateQueries({
                queryKey: ["getUserBusinessList"],
              });
              void queryClient.invalidateQueries({ queryKey: ["getSidebarBusinessList"] });

              toast.success("آواتار کسب و کار ویرایش گردید");
              navigate(`/business/${businessType}/${businessId}`);
            }
          });
        } catch (error) {
          handleErrorApi(error);
        }

        //console.log(url);
        // fieldChange(url);
      } else {
        //fieldChange("");
      }

      return session;
    } catch (err) {
      //fieldChange("");
      console.error("Error uploading file:", err);
      throw err; // Re-throw to handle errors elsewhere if needed
    } finally {
      setFileIsUploading(false);
    }
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      setFile(acceptedFiles[0]);
      // fieldChange(URL.createObjectURL(acceptedFiles[0]))
      setFileUrl(URL.createObjectURL(acceptedFiles[0]));
      handleUpload({ file: acceptedFiles[0], pic_type: "USER_PROFILE" });
    },
    [file],
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  return (
    <>
      <Popup
        trigger={
          <img
            src={src ? src : emptyImage}
            alt="sd"
            className={cn("max-w-[200px] max-h-[150px]", className)}
            width={width}
            height={height}
          />
        }
        modal
      >
        {(close) => (
          <div className="bg-neutral-10  p-3 md:min-w-[400px] md:min-h-[400px] rounded-xl flex flex-col gap-4  ">
            {src ? (
              <div className=" bg-neutral-30   rounded-xl flex-1 flex justify-center items-center ">
                {uploading ? (
                  <div className="w-full">
                    <ProgressBar
                      completed={progress}
                      maxCompleted={100}
                      className="w-full"
                      bgColor="#39A78E"
                    />
                  </div>
                ) : (
                  <>
                    <img src={src} alt="sd" className="max-w-[60vw] max-h-[60vh] w-full h-full " />
                  </>
                )}
              </div>
            ) : (
              <div className="bg-neutral-30   rounded-xl flex-1 flex justify-center items-center">
                <img
                  src={emptyImage}
                  alt="emptyAvatar"
                  className="size-1 h-full rounded-lg min-w-[150px] min-h-[150px]"
                />
              </div>
            )}

            <div className="flex justify-center gap-2 p-2 ">
              <div
                {...getRootProps()}
                className="flex flex-col flex-center   bg-dark-3 rounded-xl cursor pointer gap-2 "
              >
                <input {...getInputProps()} className="cursor-pointer" />
                <button className="btn-container">
                  {fileIsUploading ? (
                    <>
                      <div className="w-4 h-4">
                        <Loader />
                      </div>
                      <p> در حال ذخیره سازی ...</p>
                    </>
                  ) : (
                    "ویرایش"
                  )}
                </button>

                {error && <div style={{ color: "red" }}>خطا:{error.message} </div>}
              </div>
              <button onClick={() => close()} className="btn-cancel">
                انصراف
              </button>
            </div>
          </div>
        )}
      </Popup>
    </>
  );
};

export default BusinessImageContainer;
